import DropItem from "../../ddTxtImg/model/DropItem";

class CompareItemModel extends DropItem {

    constructor() {
        super()
        this.compareItemId = 0;
        this.compareItemIndex = 0;
        this.compareItemName = ""
    }
    getAsJson = () => {
        let obj = {}
        obj.compareItemId = this.compareItemId
        obj.compareItemIndex = this.compareItemIndex
        obj.compareItemName = this.compareItemName
        obj.solvedDragItem = this.solvedDragItem.getAsJson()

        return obj
    }


    initFromJson = (obj) => {
        this.compareItemId = obj.compareItemId
        this.compareItemIndex = obj.compareItemIndex
        this.compareItemName = obj.compareItemName
        this.solvedDragItem.initFromJson(obj.solvedDragItem)
    }

}
export default CompareItemModel
